module.exports = __webpack_public_path__ + "3510b8e6bd6a37322ca50ebb1f30639e.MP3";